import { createContext, Dispatch, useContext } from 'react'

import { noop } from '../../../../utils/noop'
import { getInitialState } from '../state/reducer'
import { SecondTryAction } from '../typings/SecondTryAction'
import { SecondTryState } from '../typings/SecondTryState'
import { StateIntroData } from '../typings/StateIntroData'

export type Update = (update: Partial<StateIntroData>) => void

export type Dispatchers = {
  dispatch: Dispatch<SecondTryAction>
}

export type SecondTryContextType = SecondTryState & Dispatchers

export const SecondTryContext = createContext<SecondTryContextType>({
  dispatch: noop,
  ...getInitialState({ prefilledInput: '' }),
})

export const useSecondTryContext = () => useContext(SecondTryContext)
